import React from "react";

type StarProps = {
  size?: number;
  borderColor?: string;
  fillColor?: string;
  className?: string;
};

export const Star: React.FC<StarProps> = ({
  size = 40,
  borderColor = "#FFD700", // amarillo por defecto
  fillColor = "transparent",
  className = "",
}) => {
  return (
    <div
      className={`flex items-center justify-center ${className}`}
      style={{ width: size, height: size }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill={fillColor}
        stroke={borderColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M12 .587l3.668 7.431L24 9.748l-6 5.849L19.335 24 12 19.897 4.665 24 6 15.597 0 9.748l8.332-1.73L12 .587z" />
      </svg>
    </div>
  );
};
